import { useStore } from '@hooks';
import { REQUIRED_SCRIPT_TAG_PARAMS } from '../constants';

export const useScriptTag = () => {
    const store = useStore();
    const { scriptTag, isShopify } = store.accountsStore;

    const requiredParams = isShopify
        ? REQUIRED_SCRIPT_TAG_PARAMS.filter((param) => param !== 'shopDomain')
        : REQUIRED_SCRIPT_TAG_PARAMS;

    const urlMatch = scriptTag.match(/src="([^"]+)"/);

    const url = urlMatch ? urlMatch[1] : '';

    let hasRequiredParams = false;

    if (url) {
        const urlObject = new URL(url);

        const extractedKeys = Array.from(urlObject.searchParams.keys());

        hasRequiredParams = requiredParams.every((key) => extractedKeys.includes(key));
    }

    return { hasRequiredParams, scriptTag };
};
